<template>
  <div>
    <a
      class="text-blueGray-500 block"
      href="#pablo"
      ref="btnDropdownRef"
      v-on:click="toggleDropdown($event)"
    >
      <div class="items-center flex">
        <span
          class="w-12 h-12 text-sm text-white bg-blueGray-200 inline-flex items-center justify-center rounded-full"
        >
          <img
            alt="..."
            class="w-full rounded-full align-middle border-2 border-white shadow-lg"
            :src="currentUserAvatar"
          />
        </span>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-20 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
      v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow
      }"
    >
      <router-link
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        to="/admin/profile"
      >
        Profile
      </router-link>
      <div class="h-0 my-2 border border-solid border-blueGray-100" />
      <a
        href="javascript:void(0);"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        @click="handleLogout"
      >
        Logout
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { createPopper } from "@popperjs/core";
import * as Helpers from "@/helpers";
import router from "@/router";
import { LOGOUT } from "@/store/actions.type";

import image from "@/assets/imgs/user-profile.png";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
      image
    };
  },
  computed: {
    currentUserAvatar() {
      return Helpers.getAvatar(this.currentUser.email);
    },
    ...mapGetters(["currentUser"])
  },
  methods: {
    toggleDropdown(event) {
      event.preventDefault();
      if (this.dropdownPopoverShow) {
        this.dropdownPopoverShow = false;
      } else {
        this.dropdownPopoverShow = true;
        createPopper(this.$refs.btnDropdownRef, this.$refs.popoverDropdownRef, {
          placement: "bottom-start"
        });
      }
    },
    handleLogout() {
      this.$store.dispatch(LOGOUT).then(() => {
        router.push({ name: "auth" });
      });
    }
  }
};
</script>
